import { API_URL } from "@/config/config";
import { formatOptions } from "@/helpers/helpers";
import $http from "@/Utils/$http";

const directory = 'categories/'
export const getCategoryData = async (id) => (await $http.get(API_URL + directory + id)).data;
export const getCategoriesList = async (params) => (await $http.get(API_URL + directory, {params})).data;

export const getCategoryOptionsList = async () => formatOptions((await getCategoriesList()).data);

export const createCategory = async (data) => (await $http.post(API_URL + directory, data)).data;
export const updateCategory = async (data) => (await $http.post(API_URL + directory + data.id, data)).data;
export const deleteCategory = async (id) => (await $http.post(API_URL + directory + id+ '/delete')).data;
export const sortCategories = async (data) => (await $http.post(API_URL+ directory + 'sort', data)).data;



const settingsLink = (id) => `${API_URL + directory + id }/settings/`;

export const setCategorySetting = async function (id, data) {
  return await $http.post(settingsLink(id) + 'set', {
    settings : data
  })
}

// const categoriesLink = (params) => `${API_URL}business/${params.businessId}/categories/`;

// export const getCategoryData = async (params, id) => (await $http.get(categoriesLink(params) + id)).data;
// export const getCategoriesList = async (params) => (await $http.get(categoriesLink(params), { params })).data;

// export const getCategoryOptionsList = async (params) => formatOptions((await getCategoriesList(params)).data);

// export const createCategory = async (params, data) => (await $http.post(categoriesLink(params), data)).data;
// export const updateCategory = async (params, data) => (await $http.post(categoriesLink(params) + data.id, data)).data;
// export const deleteCategory = async (params, id) => (await $http.post(categoriesLink(params) + id + '/delete')).data;
// export const sortCategories = async (params, data) => (await $http.post(categoriesLink(params) + 'sort', data)).data;

// const settingsLink = (params, id) => `${categoriesLink(params) + id }/settings/`;

// export const setCategorySetting = async function (params, id, data) {
//   return await $http.post(settingsLink(params, id) + 'set', {
//     settings: data
//   });
// };